import * as React from 'react'

import * as styles from './quellen.css'

import * as classnames from 'classnames'
import { observer } from 'mobx-react'
import { injectStores, StoreComponent } from '../../store'
import { runInAction, observable } from 'mobx'
import { ContentQuellen } from '../storydoc/storydocStoreContent'
import { bind } from 'bind-decorator'

@injectStores
@observer
export class Quellen extends StoreComponent {
  @observable.ref quellen: ContentQuellen | null = null
  @observable quellenType = 'film'

  scrollElem: HTMLDivElement | null = null

  filmQuellenDiv: HTMLDivElement | null = null
  bildQuellenDiv: HTMLDivElement | null = null
  textQuellenDiv: HTMLDivElement | null = null

  constructor (props: any, context: any) {
    super(props, context)
    setTimeout(() => this.fetchQuellen(), 350)
  }

  // componentDidMount () {
  //   if (this.scrollElem) {
  //     this.scrollElem.addEventListener('scroll', this.handleScroll, true)
  //   }
  // }

  async fetchQuellen () {
    const quellen = await this.store.storyDocContent.fetchQuellen()
    runInAction(() => {
      this.quellen = quellen
    })
  }

  @bind
  handleScroll () {
    if (this.filmQuellenDiv && this.bildQuellenDiv && this.textQuellenDiv) {
      const filmRect = this.filmQuellenDiv.getBoundingClientRect()
      const bildRect = this.bildQuellenDiv.getBoundingClientRect()
      const textRect = this.textQuellenDiv.getBoundingClientRect()
      if (filmRect.height && filmRect.top + filmRect.height > this.store.storeCommon.window.height) {
        this.quellenType = 'film'
      } else if (filmRect.top + filmRect.height < 0 && bildRect.height && bildRect.top + bildRect.height > this.store.storeCommon.window.height) {
        this.quellenType = 'bild'
      } else if (bildRect.top + bildRect.height < 0 && textRect.height && textRect.top + textRect.height > this.store.storeCommon.window.height) {
        this.quellenType = 'text'
      }
    }
    // console.log(this.filmQuellenDiv && this.filmQuellenDiv.getBoundingClientRect())
  }

  @bind
  scrollToQuellen (ref: any, quellenType: string) {
    this.quellenType = quellenType
    ref.scrollIntoView(
      // { block: 'start', inline: 'nearest', behavior: 'smooth' }
    )
  }

  render () {
    // console.log(this.bildQuellenDiv && this.bildQuellenDiv.getBoundingClientRect())
    const filmQuellen = []
    const bildQuellen = []
    const textQuellen = []
    if (this.quellen) {
      for (const section of this.quellen.sections) {
        const entries = []
        for (const entryTitle in section.entries) {
          entries.push(
            <div className={ styles.entryBox } key={ entryTitle }>
              <div className={ styles.chapterTitle }>{ entryTitle }</div>
              <div className={ styles.yellowBorder }></div>
              <div className={ styles.chapterCaption } dangerouslySetInnerHTML={{ __html: section.entries[entryTitle] }}/>
            </div>
          )
        }
        if (section.title === 'Filmquellen' || section.title === 'Film Sources') {
          filmQuellen.push(
            <div className={ styles.quelleBox } key={ section.title }>
              {/* { this.store.breakpoints.desktop && <div className={ styles.chapterTitle }>{ section.title }</div> } */}
              { entries }
            </div>
          )
        } else if (section.title === 'Bildquellen' || section.title === 'Picture Sources') {
          bildQuellen.push(
            <div className={ styles.quelleBox } key={ section.title }>
              {/* { this.store.breakpoints.desktop && <div className={ styles.chapterTitle }>{ section.title }</div> } */}
              { entries }
            </div>
          )
        } else if (section.title === 'Textquellen' || section.title === 'Text Sources') {
          textQuellen.push(
              <div className={styles.quelleBox} key={ section.title }>
                {/* { this.store.breakpoints.desktop && <div className={ styles.chapterTitle }>{ section.title }</div> } */}
                { entries }
              </div>
            )
        }
      }
    }

    let contentQuellen: JSX.Element | null = null
    contentQuellen = <div className={ styles.contentBox } ref={elem => this.scrollElem = elem} onScroll={this.handleScroll}>
                        <div className={ styles.content } >
                          <div className={ styles.quellenTitle }>{this.store.storeCommon.menu.language === 'de' ? 'Literatur- und Quellenverzeichnis' : 'Sources'}</div>
                          <div className={ styles.quellenArea } ref={ elem => this.filmQuellenDiv = elem }>{ filmQuellen }</div>
                          <div className={ styles.quellenArea } ref={ elem => this.bildQuellenDiv = elem }>{ bildQuellen }</div>
                          <div className={ styles.quellenArea } ref={ elem => this.textQuellenDiv = elem }>{ textQuellen }</div>
                        </div>
                     </div>

    let quellenList: JSX.Element | null = null
    quellenList = <div className={styles.list}>
                    <div className={ classnames(styles.listItem, this.quellenType === 'film' ? styles.active : null) } onClick={ () => this.scrollToQuellen(this.filmQuellenDiv, 'film') }>{this.quellen ? this.quellen.sections[0].title : ''}</div>
                    <div className={ classnames(styles.listItem, this.quellenType === 'bild' ? styles.active : null) } onClick={ () => this.scrollToQuellen(this.bildQuellenDiv, 'bild') }>{this.quellen ? this.quellen.sections[1].title : ''}</div>
                    <div className={ classnames(styles.listItem, this.quellenType === 'text' ? styles.active : null) } onClick={ () => this.scrollToQuellen(this.textQuellenDiv, 'text') }>{this.quellen ? this.quellen.sections[2].title : ''}</div>
                  </div>

    return (
      <div className={ styles.quellenBox } >
        <div className={ styles.listBox }>{ quellenList }</div>
        { contentQuellen }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/imprintSources/quellen.tsx